import { ControllerContract } from '../architecture/ControllerContract';

import { uploadImage } from '../models/assistant/UploadImage';
import { identifyImageProducts } from '../models/assistant/IdentifyImageProducts';
import { fetchAssistantConfig } from '../models/assistant/FetchAssistantConfig';
import { productMixAndMatch } from '../models/assistant/ProductMixAndMatch';
import { productComparisonTable } from '../models/assistant/ProductComparisonTable';
import { productPacks } from '../models/assistant/ProductPacks';

export const assistantRoutes = {
    controllerPath: 'assistant',
    endpoints: {
        uploadImage,
        identifyImageProducts,
        fetchAssistantConfig,
        productMixAndMatch,
        productComparisonTable,
        productPacks
    }
} as const satisfies ControllerContract;

export type AssistantRoutes = typeof assistantRoutes;
